export enum FinancingType {
	CASH = 'CASH',
	RENTAL = 'RENTAL',
	OTHER = 'OTHER',
}
